import Bonus from '../bonus/bonus';
import styles from './bonus-list.module.scss';
import Scrollbars from 'react-custom-scrollbars-2';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames';
import { memo } from 'react';

interface BonusListProps {
	bonuses: any[]
	active: boolean
  mode?: "block" | "inline"
  header?: string;
}

export const BonusList = memo(({bonuses, active, mode="inline", header}: BonusListProps) => {
  const tabletPortrait = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const desktopS = useMediaQuery({ minWidth: 1280 });

  const bonusElements = bonuses.map((bonus, i) => { 
    return <Bonus 
      key={bonus.title} 
      active={active} 
      bonus={bonus} 
      mode={mode}
      count={bonuses.length}
    />
  });

	return (<div className={classNames(styles.container, styles[`container-${mode}`], { [styles.withoutHeader]: !header })}>
    {header && <h3 className={styles.header}>{header}</h3>}
    {(mode == "inline" && !(tabletPortrait || desktopS)) ?
		<Scrollbars autoHeight className={styles.mBottom}>
      <ul className={styles.inline}>
        {bonusElements}
      </ul>
    </Scrollbars>
    :
    <ul className={classNames(styles[mode], {[styles.mBottom]: mode == "inline" })}>
      {bonusElements}
    </ul>}
  </div>)
});